// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"431":"e333978d","507":"2c52e1cc"}[chunkId] + ".chunk.css";
};